import axios from "axios";
axios.defaults.xsrfHeaderName = "X-CSRFTOKEN";
axios.defaults.xsrfCookieName = "XCSRF-TOKEN";

const apiBaseUrl = process.env.REACT_APP_API_URL || 'http://127.0.0.1:8000/api';
console.log('API Base URL:', apiBaseUrl);
const Api = axios.create({ baseURL: apiBaseUrl });

export const getObjects = async (endpoint, token = "") => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const response = await Api.get(`/${endpoint}`, { headers });
  return response.data;
};

export const getObject = async (endPoint, id, token = "") => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  const response = await Api.get(`/${endPoint}/${id}`, { headers });
  return response.data;
};

export const addObject = async (
  endpoint,
  modelObject,
  token = "",
  isMultipart = false,
) => {
  const headers = {};

  if (token) {
    headers.Authorization = `Token ${token}`;
  }

  if (!isMultipart) {
    headers["Content-Type"] = "application/json";
  }

  return await Api.post(`/${endpoint}/`, modelObject, { headers });
};

export const updateObject = async (
  endPoint,
  modelObject,
  rowId,
  token = "",
) => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  return await Api.patch(`/${endPoint}/${rowId}/`, modelObject, { headers });
};

export const deleteObject = async (endPoint, id, token = "") => {
  const headers = token ? { Authorization: `Token ${token}` } : {};
  return await Api.delete(`/${endPoint}/${id}/`, { headers });
};
